import { URLShortenerService } from '@weave/schema-gen-ts/dist/schemas/urlshortener/v1/urlshortener.pb';
import { bindHTTP } from '@frontend/schema';

export const SchemaShortenerV1Service = bindHTTP(URLShortenerService);
export const serviceName = 'shortener-v1' as const;
